import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'

export const createProductDetailsColDefs = (canEdit: boolean) => {
  return createColDefs([
    {
      field: 'isin',
      cellStyle: { textAlign: 'center' },
      width: 110,
      pinned: 'left',
    },
    {
      field: 'description',
      width: 400,
      editable: canEdit,
    },
    {
      field: 'descriptionFull',
      headerName: 'Desc Full',
      width: 200,
      editable: canEdit,
    },
    {
      field: 'currency',
      width: 100,
      editable: canEdit,
    },
    {
      field: 'issuer',
      width: 250,
      editable: canEdit,
    },
    {
      field: 'type',
      width: 300,
      editable: canEdit,
    },
    {
      field: 'strikeDate',
      headerName: 'Strike Dt',
      width: 115,
    },
    {
      field: 'inventory',
      width: 100,
      editable: canEdit,
      valueFormatter: numberFormatter({
        delimiter: true,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }),
    },
    {
      field: 'secondaryEmail',
      headerName: 'On Email',
      width: 110,
      editable: canEdit,
    },
  ])
}

export const createAllProductsColDefs = (canEdit: boolean) => {
  return createColDefs([
    {
      field: 'ISIN',
      cellStyle: { textAlign: 'center' },
      width: 110,
      pinned: 'left',
    },
    {
      field: 'FortemRef',
      width: 115,
      editable: canEdit,
    },
    {
      field: 'Bloomberg',
      width: 185,
      editable: canEdit,
    },
    {
      field: 'Region',
      width: 90,
      editable: canEdit,
    },
    {
      field: 'Issuer',
      width: 175,
      editable: canEdit,
    },
    {
      field: 'Sedol',
      width: 97,
      editable: canEdit,
    },
    {
      field: 'Name',
      width: 350,
      editable: canEdit,
    },
    {
      headerName: 'Addl',
      groupId: 'Addl',
      children: [
        {
          field: 'Asset',
          width: 100,
          editable: canEdit,
        },
        {
          field: 'Access',
          width: 115,
          columnGroupShow: 'open',
          editable: canEdit,
        },
        {
          field: 'includeSecPage',
          width: 100,
          editable: canEdit,
          columnGroupShow: 'open',
          wrapHeaderText: true,
          autoHeaderHeight: true,
        },
        {
          field: 'Strategy',
          width: 100,
          columnGroupShow: 'open',
        },
        {
          field: 'geo',
          width: 80,
          columnGroupShow: 'open',
        },
      ],
    },
    {
      headerName: 'Market',
      groupId: 'Market',
      children: [
        {
          field: 'Date',
          width: 115,
        },
        {
          field: 'Timestamp',
          width: 115,
          columnGroupShow: 'open',
        },
        {
          field: 'Bid',
          width: 100,
          columnGroupShow: 'open',
        },
        {
          field: 'Offer',
          width: 100,
          columnGroupShow: 'open',
        },
        {
          field: 'GRY',
          width: 115,
          columnGroupShow: 'open',
        },
      ],
    },
  ])
}
